/**
 * Take over and Hand back, told to the shell and to the session that was
 * driving the page (RFC 0303 3e).
 *
 * The shell holds the latch, per page; this asks it to. The log write is what
 * makes the agent know. Take over is written as a record and wakes nobody: an
 * agent mid-errand learns it from its next action being refused. Hand back
 * queues a turn, so the agent carries on without the person typing. A page no
 * session is known to have driven writes nothing.
 */

import type { Repo } from '@automerge/automerge-repo'
import { enqueuePageHandedBack, recordPageTakenOver } from '@mod/core/run'
import { drivingSession, requestHold } from './driving'

/** The person pressed Take over on the pane whose guest is `webContentsId`. */
export function takeOverPage(
  repo: Repo | null,
  webContentsId: number,
  url: string,
): void {
  requestHold(webContentsId, true)
  const session = drivingSession(webContentsId)
  if (!repo || !session) return
  // Best effort: the page is the person's whether or not the log heard.
  void recordPageTakenOver(repo, session, { url }).catch(() => undefined)
}

/** The person pressed Hand back on that pane. */
export function handBackPage(
  repo: Repo | null,
  webContentsId: number,
  url: string,
): void {
  requestHold(webContentsId, false)
  const session = drivingSession(webContentsId)
  if (!repo || !session) return
  void enqueuePageHandedBack(repo, session, { url }).catch(() => undefined)
}
